import { render, staticRenderFns } from "./LC.vue?vue&type=template&id=514139b0&scoped=true&"
var script = {}
import style0 from "./LC.vue?vue&type=style&index=0&id=514139b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514139b0",
  null
  
)

export default component.exports